import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { Tooltip } from '@material-ui/core'
import { IGroup } from '../../types/group'
import { IPublishedSearch } from '../../types/publishedSearch'
import { IGroupParam } from '../../types/router'
import { getGroups } from '../../actions/groups'
import { REQUEST_ACCESS_URL } from '../../config/auth'
import { useSearch } from '../../hooks'
import { Main } from '../../layouts'
import {
  Button,
  SidebarMenu,
  H1,
  P,
  PublishedGraphicsList,
  ControlledInfiniteScroll,
} from '../../components'
import { StyledGroupHeader } from './styled'

export interface IGroupViewPageConnectedProps {
  groupsList: IGroup[]
  groupsLoading: boolean
  groupsLoaded: boolean
  group?: IGroup
  search: IPublishedSearch
  hasGroupAccess: boolean
  dispatch: Dispatch
}

export const GroupViewPage = ({
  match: {
    params: { groupId },
  },
  location,
  groupsList,
  groupsLoading,
  groupsLoaded,
  group,
  search,
  hasGroupAccess,
  dispatch,
}: IGroupViewPageConnectedProps & RouteComponentProps<IGroupParam>) => {
  const [takeNextChunk] = useSearch({
    isConsumer: true,
    search,
    location,
    groupId,
    dispatch,
  })

  useEffect(() => {
    if (!groupsLoaded && !groupsLoading) {
      dispatch(getGroups())
    }
  }, [dispatch, groupsLoaded, groupsLoading])

  return (
    <Main
      sidebarSecondary={
        <SidebarMenu
          caption="Graphic groups"
          menu={groupsList.map(
            ({ shortTitle: title, title: description, name }) => ({
              title,
              description,
              href: `/group/${name}`,
            })
          )}
        />
      }
      helmet={group && `Reuters Graphics. Portal: ${group.shortTitle}`}
    >
      {group && (
        <>
          <StyledGroupHeader>
            <div>
              <H1>{group.shortTitle}</H1>
              {group.description && <P mt={2}>{group.description}</P>}
            </div>
            {hasGroupAccess ? (
              <div className="right">
                <Button
                  variant="contained"
                  color="primary"
                  to={`/group/${groupId}/publish`}
                >
                  To Publishing Area
                </Button>
              </div>
            ) : (
              <Tooltip title="Link to thehub page for requesting access to the group">
                <Button
                  variant="outlined"
                  color="primary"
                  href={REQUEST_ACCESS_URL}
                >
                  Request access
                </Button>
              </Tooltip>
            )}
          </StyledGroupHeader>
          <ControlledInfiniteScroll
            component={PublishedGraphicsList}
            takeNextChunk={takeNextChunk}
            search={search}
          />
        </>
      )}
    </Main>
  )
}
